import { Routes } from '@angular/router';
import { authGuard } from '@core/guards/auth.guard';
import { signInGuard } from '@features/authentication/guards/sign-in.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'app',
    pathMatch: 'full',
  },
  {
    path: 'authentication',
    children: [
      {
        path: 'sign-in',
        canActivate: [signInGuard],
        loadComponent: () =>
          import('@features/authentication/components/sign-in/sign-in.component').then(
            m => m.SignInComponent
          ),
      },
      {
        path: 'sign-up',
        canActivate: [signInGuard],
        loadComponent: () =>
          import('@features/authentication/components/sign-up/sign-up.component').then(
            m => m.SignUpComponent
          ),
      },
      {
        path: 'sign-out',
        loadComponent: () =>
          import('@features/authentication/components/sign-out/sign-out.component').then(
            m => m.SignOutComponent
          ),
      },
      {
        path: '',
        redirectTo: 'sign-in',
        pathMatch: 'full',
      },
    ],
  },
  {
    // Everything behind the shell requires a session.
    path: 'app',
    canActivate: [authGuard],
    loadComponent: () =>
      import('@core/components/shell/shell.component').then(m => m.ShellComponent),
    loadChildren: () => import('@core/components/shell/shell.routes').then(m => m.shellRoutes),
  },
  {
    // Living design-system gallery. Unguarded on purpose — it is a development
    // aid and renders no user data.
    path: 'design-system',
    loadChildren: () =>
      import('@features/design-system/design-system.routes').then(m => m.designSystemRoutes),
  },
  {
    path: '**',
    redirectTo: 'app',
  },
];
